import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import {
  IPagination,
  IPaginationResult,
  IRequestResult,
  IResult,
} from "../../../../../common/interfaces";
import { environment as env } from "../../../../../../environments/environment.prod";
import { AbstractService } from "app/services/abstract.service";
import { IUpdateSubRoute } from "../interfaces/update-sub-route.interface";
import { ICreateManyBPFrecuency, ICreateSubRouteFrequencyBP } from "./interfaces/create-sub-route-bp-frequency";
import SubRouteBusinessPartnersAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/routing/sub-route/sub-route-frequency-bp/sub-route-frequency-bp.entity";
import { BusinessPartnerBySubRoute } from "../interfaces/busines-partner-by-sub-route.interface";

const apiUrl = env.API_ROUTING_URL;
const moduleName = "sub_route_bps_frequencies";

@Injectable({
  providedIn: "root",
})
export class SubRouteFrequenciesBPService extends AbstractService<
SubRouteBusinessPartnersAttributes,
ICreateSubRouteFrequencyBP,
  IUpdateSubRoute
> {
  constructor(
    http: HttpClient,
  ) {
    super(apiUrl, moduleName, http);
  }

  /**
   * Pagination
   * @param options Pagination options
   * @returns Paginated data
   */
  findClientByFrequency(subRouteId: string,frequencyId:string): Observable<IResult<BusinessPartnerBySubRoute>> {
    const API_URL: string = `${apiUrl}api/${moduleName}/${subRouteId}/${frequencyId}`;
    return this.http.get<IResult<BusinessPartnerBySubRoute>>(API_URL);
  }

  findClientByWeekDay(subRouteId: string,day:number): Observable<IResult<BusinessPartnerBySubRoute>> {
    const API_URL: string = `${apiUrl}api/${moduleName}/by_day/${subRouteId}/${day}`;
    return this.http.get<IResult<BusinessPartnerBySubRoute>>(API_URL);
  }

  /**
   * 
   * @param fatherId 
   * @param id  
   * @returns 
   */
  createBusinessPartnerFromFrecuency(fatherId: string,id:string,selfId:string): Observable<IRequestResult<any>> {
    const API_URL: string = `${apiUrl}api/${moduleName}/create/${fatherId}/${id}/${selfId}`;   
    return this.http.patch<IRequestResult<any>>(API_URL, {});
  }

  createManyBusinessPartnerFromFrecuency(fatherId: string,id:string, bpids:ICreateManyBPFrecuency): Observable<IRequestResult<any>> {
    const API_URL: string = `${apiUrl}api/${moduleName}/create_many/${fatherId}/${id}`;   
    return this.http.patch<IRequestResult<any>>(API_URL, bpids);
  }  
    
  deleteBusinessPartnerFromFrecuency(subRouteId: string, frecuencyId: string, bpId: string): Observable<IResult<any>> {
    const API_URL: string = `${apiUrl}api/${moduleName}/delete/${subRouteId}/${frecuencyId}/${bpId}`
    return this.http.delete<IResult<any>>(API_URL);
  }

  deleteManyBusinessPartnerFromFrecuency(fatherId: string,id:string, bpids:ICreateManyBPFrecuency): Observable<IRequestResult<any>> {
    const API_URL: string = `${apiUrl}api/${moduleName}/delete_many/${fatherId}/${id}`;   
    return this.http.delete<IRequestResult<any>>(API_URL, { body: bpids });
  }  

  updatePositionsBusinessPartnerFrecuency(SubRouteId: string, frequencyId: string, data: string[]): Observable<IRequestResult<SubRouteBusinessPartnersAttributes>> {
    const API_URL: string = `${apiUrl}api/${moduleName}/update_positions/${SubRouteId}/${frequencyId}`;   
    return this.http.patch<IRequestResult<SubRouteBusinessPartnersAttributes>>(API_URL, data);
  }

  updatePositionsBusinessPartnerWeekDay(SubRouteId: string, weekCode: number, data: string[]): Observable<IRequestResult<SubRouteBusinessPartnersAttributes>> {
    const API_URL: string = `${apiUrl}api/${moduleName}/update_positions_by_day/${SubRouteId}/${weekCode}`;   
    return this.http.patch<IRequestResult<SubRouteBusinessPartnersAttributes>>(API_URL, data);
  }

   moveManyBusinessPartnerFromFrecuency(fatherId: string,bpids:ICreateManyBPFrecuency): Observable<IRequestResult<any>> {
    const API_URL: string = `${apiUrl}api/${moduleName}/move_many/${fatherId}`;   
    return this.http.patch<IRequestResult<any>>(API_URL, bpids);
  } 
}
